// extracted by mini-css-extract-plugin
module.exports = {"htLogo":"htlogo_htLogo__oyy9f","defaultCursor":"htlogo_defaultCursor__uPsKW","fadein":"htlogo_fadein__A7VGa","loading":"htlogo_loading__eU3FS"};